import type { PumpsQueryVariables, Pumps_Bool_Exp } from "gql/api";
import { Order_By } from "gql/api";

export function restorePumps(arr: Array<string>): Pumps_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function deletePumps(arr: Array<string>): Pumps_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export const defaultPumpVars: PumpsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { series_model: Order_By.Asc }
  ]
};

export const adminPumpVars: PumpsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { series_model: Order_By.Asc }
  ]
};

export const kocPumpVars: PumpsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { series_model: Order_By.Asc }
  ],
  where: {
    _or: [
      { include_koc_timestamp: { _is_null: false } },
      { only_koc_timestamp: { _is_null: false } }
    ]
  }
};
export const ecopetrolPumpVars: PumpsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { series_model: Order_By.Asc }
  ],
  where: {
    _or: [
      { include_ecopetrol_timestamp: { _is_null: false } },
      { only_ecopetrol_timestamp: { _is_null: false } }
    ]
  }
};
